import React from 'react';
import './FeatureBadge.css';

const FeatureBadge = ({ text, variant = 'primary' }) => {
  return (
    <span className={`feature-badge feature-badge--${variant}`}>
      {text}
    </span>
  );
};

export default FeatureBadge;